import messages from '../../../locale/messages';
import { validateDate, validateEmail, validatePhoneNumber } from '../../../helpers/validation';

const validate = values => {

  const errors = {}

  if( !values.name || values.name.toString().trim() == '' ) {
    errors.name = messages.required;
  }

  if( !values.email || values.email.toString().trim() == '' ) {
    errors.email = messages.required;
  }
  else if( !validateEmail(values.email) ) {
    errors.email = messages.invalid;
  }

  if( !values.phoneNumber || values.phoneNumber.toString().trim() == '' ) {
    errors.phoneNumber = messages.required;
  }
  else if( !validatePhoneNumber(values.phoneNumber) ) {
    errors.phoneNumber = messages.invalid;
  }

  if( !values.preferredDate || values.preferredDate.toString().trim() == '' ) {
    errors.preferredDate = messages.required;
  }
  else if( !validateDate(values.preferredDate) ) {
    errors.preferredDate = messages.invalid;
  }

  return errors
}

export default validate



// WEBPACK FOOTER //
// src/components/ViewListing/BookAViewingModal/validate.js